<template>
	<div class="tests">
		<div v-if="showadvancedsearch">
			<div class="row">
				<div class="col-md-4" v-if="canViewAllTests || isTeacher">
					<div class="form-group">
						<label>{{ $t("student") }}</label>
						<div
							class="pseudo-input mb-3"
						>
							<input
								type="search"
								class="input-bare w-full flex-1"
								placeholder="Student"
								v-if="!search.students.length"
								@click="selectStudent"
								@keyup.enter="selectStudent"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(student, index) in search.students"
								v-bind:key="index"
							>
								{{ student.displayName }}
								<a @click="removeStudent(student)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="search.students.length"
								@click="selectStudent"
								@keyup.enter="selectStudent"
								tabindex="0"
								:aria-label="$t('student') + ' ' + $t('add')"
							>
								<b-icon icon="plus"></b-icon> {{ $t("add") }}
							</span>
							<span
								class="badge badge-danger badge-sm mr-2 mb-2"
								v-if="search.students.length"
								@click="search.students=[];updateSearch()"
								@keyup.enter="search.students=[];updateSearch()"
								tabindex="0"
								:aria-label="$t('student') + ' ' + $t('clear-all')"
							>
								<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-4" v-if="canViewAllTests || isStudent">
					<div class="form-group">
						<label>{{ $t("teacher") }}</label>
						<div
							class="pseudo-input mb-3"
						>
							<input
								type="search"
								class="input-bare w-full flex-1"
								placeholder="Teacher"
								v-if="!search.teachers.length"
								@click="selectTeacher"
								@keyup.enter="selectTeacher"
								:aria-label="$t('teacher')"
							/>
							<span
								class="badge badge-secondary badge-sm mr-2 mb-2"
								v-for="(teacher, index) in search.teachers"
								v-bind:key="index"
							>
								{{ teacher.displayName }}
								<a @click="removeTeacher(teacher)"><b-icon icon="x"></b-icon></a>
							</span>
							<span
								class="badge badge-primary badge-sm mr-2 mb-2"
								v-if="search.teachers.length"
								@click="selectTeacher"
								@keyup.enter="selectTeacher"
								tabindex="0"
								:aria-label="$t('teacher') + ' ' + $t('add')"
							>
								<b-icon icon="plus"></b-icon> {{ $t("add") }}
							</span>
							<span
								class="badge badge-danger badge-sm mr-2 mb-2"
								v-if="search.teachers.length"
								@click="search.teachers=[];updateSearch()"
								@keyup.enter="search.teachers=[];updateSearch()"
								tabindex="0"
								:aria-label="$t('teacher') + ' ' + $t('clear-all')"
							>
								<b-icon icon="x"></b-icon> {{ $t('clear-all') }}
							</span>
						</div>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<!-- passed / failed / both -->
						<label>{{ $t("passed-failed") }}</label>
						<select v-model="search.haspassed" class="form-control" @change="updateSearch">
							<option :value="null">{{ $t('all') }}</option>
							<option value="1">{{ $t('passed') }}</option>
							<option value="0">{{ $t('failed') }}</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("programme") }}</label>
						<select class="form-control" v-model="search.programme" @change="updateSearch()">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="programme in $config.getValue('programmes')"
							:key="programme.Id"
							:value="programme"
							>{{ programme.Name}}
							</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("year") }}</label>
						<select class="form-control" v-model="search.year" @change="updateSearch()">
							<option :value="null">{{ $t("any") }}</option>
							<template v-if="search.programme">
								<option
								v-for="year in parseInt(search.programme.CourseLengthYears)"
								:key="year"
								:value="year"
								>{{ year }}
								</option>
								<option :value="parseInt(search.programme.CourseLengthYears) + 1">{{ $t('graduated') }}</option>
							</template>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t("group") }}</label>
						<select class="form-control" v-model="search.group" @change="updateSearch()">
							<option :value="null">{{ $t("any") }}</option>
							<option
							v-for="(name, id) in $config.getValue('groups')"
							:key="id"
							:value="id"
							>{{ name }}
							</option>
						</select>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<!-- marked HasPassed=1|0 / not marked (HasPassed = -1) -->
						<label>{{ $t("marked") }}</label>
						<select v-model="search.marked" class="form-control" @change="updateSearch">
							<option :value="null">{{ $t('all') }}</option>
							<option value="1">{{ $t('marked') }}</option>
							<option value="0">{{ $t('not-marked') }}</option>
						</select>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<!-- competencytestfilter_id (Category) -->
						<label>{{ $t("filter") }}</label>
						<input
							type="text"
							:value="search.filter ? search.filter.caption : null"
							class="form-control"
							@click="selectFilter"
							@keyup.enter="selectFilter"
						/>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<!-- test_id (Test) -->
						<label>{{ $t("test") }}</label>
						<input
							type="text"
							:value="search.test ? search.test.name : null"
							class="form-control"
							@click="selectTest"
							@keyup.enter="selectTest"
						/>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-md-4">
					<div class="form-group">
						<label>{{  $t('abandoned') }}</label>
						<select
							v-model="search.abandoned"
							class="form-control"
							@change="updateSearch"
						>
							<option :value="null" selected>{{ $t('exclude-abandoned') }}</option>
							<option value="include">{{ $t('include-abandoned') }}</option>
							<option value="only">{{  $t('only-abandoned') }}</option>
						</select>
					</div>
				</div>

				<!-- Date range (from - to) on competencytestsession.comptencytest_datetaken -->
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('from') }}</label>
						<input
							type="date"
							v-model="search.datefrom"
							class="form-control"
							@change="updateSearch"
						>
					</div>
				</div>
				<div class="col-md-4">
					<div class="form-group">
						<label>{{ $t('to') }}</label>
						<input
							type="date"
							v-model="search.dateto"
							class="form-control"
							@change="updateSearch"
						>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-8">
				<div class="input-group mb-2">
					<input
						type="text"
						:placeholder="$t('search-ellipses')"
						v-model="search.q"
						class="form-control form-control-lg"
						@keyup.enter="newSearch"
					/>
					<div class="input-group-append">
						<button class="btn btn-primary" type="button" @click="newSearch">
							<b-icon icon="search"></b-icon>
						</button>
						<button
							class="btn btn-outline-primary"
							v-on:click="toggleAdvancedSearch()"
						>
							{{ $t("advanced") }}
						</button>
					</div>
				</div>
			</div>
			<div class="col-md-4">
				<router-link class="btn btn-primary btn-lg mb-3 mr-2" to="/tests/new">{{
					$t("new-test")
				}}</router-link>
				<button class="btn btn-secondary btn-lg mb-3" @click="getCompetencyTestSessions()"><b-icon icon="arrow-clockwise"></b-icon></button>
				<div class="float-right">
					<a id="popover-target-download" class="btn btn-secondary btn-lg mr-2 mb-3" tabindex="0">
						<b-icon icon="download"></b-icon>
					</a>
					<b-popover target="popover-target-download" triggers="focus" placement="bottom" ref="popover">
						<template #title>{{ $t('download') }}</template>
						<b-button @click="downloadFormResponses('csv')" class="mr-1 mb-1">{{ $t('csv') }} ({{ $tc('n-max', 1000) }})</b-button>
						<b-button @click="downloadFormResponses('pdf')">{{ $t('pdf') }} ({{ $tc('n-max', 30) }})</b-button>
					</b-popover>
				</div>
			</div>
		</div>

		<InfiniteScroll
			scrollElementId="main"
			type="CompetencyTestSession"
			:dataUrl="`${$settings.APIBaseURL}/competencytests/session/list`"
			dataProperty="results"
			class="list-group border-radius-2 no-border"
			itemClass="list-group-item"
			@selectItem="selectCompetencyTest"
			ref="infinitescroll"
			idProperty="CompetencyTestSessionID"
		/>


	</div>
</template>

<script>
import InfiniteScroll from "src/components/InfiniteScroll";

export default {
	components: {
		InfiniteScroll
	},
	data: function() {
		return {
			search: {
				q: "",
				students: [],
				teachers: [],
				programme: null,
				year: null,
				group: null,
				haspassed: null,
				marked: null,
				filter: null,
				test: null,
				datefrom: null,
				dateto: null,
				abandoned: null,
			},
			showadvancedsearch: false,
			filters: [],
			tests: []
		};
	},
	mounted() {

		Promise.all([this.getCompetencyTests(), this.getCompetencyTestFilters()]).then(() => {
			this.setSearchDefaults();
			this.tryGetSavedSearch();

			if(this.$route.params.list == 'actionrequired') {
				this.search.marked = '0';
			}
			if(this.$route.params.list == 'completed') {
				this.search.marked = '1';
			}

			this.getCompetencyTestSessions();
		});

	},
	methods: {
		selectFilter() {
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-filter"),
				selectCallback: (selection) => {
					if(this.search.filter == selection) {
						this.search.filter = null;
					} else {
						this.search.filter = selection;
					}
					this.updateSearch();
					this.$store.commit("closeModal");
				},
				selected: this.search.filter ? [this.search.filter] : [],
				data: this.filters,
				captionKey: "caption"
			});
		},
		selectTest() {
			this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-test"),
				selectCallback: (selection) => {
					if(this.search.test == selection) {
						this.search.test = null;
					} else {
						this.search.test = selection;
					}
					this.updateSearch();
					this.$store.commit("closeModal");
				},
				selected: this.search.test ? [this.search.test] : [],
				data: this.filteredTests,
				captionKey: "name"
			});
		},
		selectStudent() {
			const self = this;
			this.$users.getStudents.call(this).then((students) => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-student"),
					selectCallback: function (selection) {
						const isSelected = self.search.students.find((student, i) => {
							if (student.id === selection.id) {
								self.$delete(self.search.students, i);
								return true;
							}
						});
						if (!isSelected) {
							self.search.students.push(selection);
						}
						self.updateSearch();
					},
					selected: this.search.students,
					data: students,
					captionKey: "displayName",
                    subcaptionKey: "studentid",
					studentSearchFilters: true,
					selectAllBtn: true
				});
			});
		},
		removeStudent(selection) {
			const self = this;
			self.search.students.find((student, i) => {
				if (student.id === selection.id) {
					self.$delete(self.search.students, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
		selectTeacher() {
			const self = this;
			this.$users.getTeachers.call(this).then((teachers) => {
				const processedTeachers = teachers.map((teacher) => {
				if (teacher.status && teacher.status.toLowerCase() === "closed") {
					teacher.subcaption = this.$t("(Closed)");
				}
				return teacher;
				});
				this.$store.commit("openModal", {
				type: "selector",
				title: this.$t("select-a-teacher"),
				selectCallback: function (selection) {
					const isSelected = self.search.teachers.find((teacher, i) => {
					if (teacher.id === selection.id) {
						self.$delete(self.search.teachers, i);
						return true;
					}
					});
					if (!isSelected) {
					self.search.teachers.push(selection);
					}
					self.updateSearch();
				},
				selected: this.search.teachers,
				data: processedTeachers,
				captionKey: "displayName",
				subcaptionKey: "subcaption",
				selectAllBtn: true
				});
			});
		},

		removeTeacher(selection) {
			const self = this;
			self.search.teachers.find((teacher, i) => {
				if (teacher.id === selection.id) {
					self.$delete(self.search.teachers, i);
					self.updateSearch();
					return true;
				}
			});
			return false;
		},
		setSearchDefaults(){
			this.search = {
				q: "",
				students: [],
				teachers: [],
				programme: null,
				year: null,
				group: null,
				haspassed: null,
				marked: null,
				filter: null,
				test: null,
				datefrom: null,
				dateto: null
			};
			for(var key in this.search){
				if(key in this.$route.query){
					this.search[key] = this.$route.query[key];
				}
			};
		},
		toggleAdvancedSearch() {
			if(this.showadvancedsearch){
				localStorage.removeItem('cafs_tests_savedsearch');
				this.setSearchDefaults();
				this.showadvancedsearch = false;
				this.getCompetencyTestSessions();
			} else {
				this.showadvancedsearch = true;
			}
		},
		newSearch() {
			this.getCompetencyTestSessions();
		},
		updateSearch() {
			var body = JSON.parse(JSON.stringify(this.search));
			body.q = null;
			localStorage.setItem('cafs_tests_savedsearch', JSON.stringify(body));
			this.getCompetencyTestSessions();
		},
		tryGetSavedSearch() {
			var savedsearch = localStorage.getItem('cafs_tests_savedsearch');
			var data = JSON.parse(savedsearch);
			if(data){
				for(var key in data){
					this.search[key] = data[key];
				};
				if(this.canViewAllTests) {
					this.showadvancedsearch = true;
				}
			}
		},
		selectCompetencyTest(test) {
			this.$router.push(`/tests/${test.CompetencyTestSessionID}`);
		},
		getListQueryBody() {
			const body = {};

			body.student = this.search.students;
			body.teacher = this.search.teachers;
			body.year = this.search.year;
			body.group = this.search.group;

			if (this.search.programme) body.programme = this.search.programme.Id;
			if (this.search.marked) body.marked = this.search.marked;
			if (this.search.haspassed) body.haspassed = this.search.haspassed;
			if (this.search.test) body.test = this.search.test.id;
			if (this.search.filter) body.filter = this.search.filter.id;
			if (this.search.datefrom) body.date_from = this.search.datefrom;
			if (this.search.dateto) body.date_to = this.search.dateto;
			if (this.search.q) body.q = this.search.q;
			if (this.search.abandoned) body.abandoned = this.search.abandoned

			return body;

		},
		getCompetencyTestSessions() {
			this.$refs.infinitescroll.getData("replace", this.getListQueryBody());
		},
		downloadFormResponses(format) {
			let body = {};
			if(this.search.q){
				body = {
					q: this.search.q
				}
			} else {
				body = {
					username: this.$UserSession.getValue.call(this, "username"),
					authToken: this.$UserSession.getValue.call(this, "authToken"),
					download: JSON.stringify(Object.assign(this.getListQueryBody(), {
						format: format
					}))
				};

    			const url = `${this.$settings.APIBaseURL}/competencytests/session/list?` + new URLSearchParams(body).toString();
    			//alert(url);
    			window.open(url);

    			//let routeData = this.$router.resolve({href: `${this.$settings.APIBaseURL}/forms/response/listall?`, query: body});
    			//alert(routeData.href);
				//window.open(routeData.href, '_blank');

			}
		},
		getCompetencyTestFilters() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/filter/list`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.filters = json.filters;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		},
		getCompetencyTests() {
			return this.$cfetch(`${this.$settings.APIBaseURL}/competencytests/test/list`)
			.then((json) => {
				if (json.status == 'SUCCESS') {
					this.tests = json.competencytests;
				}
			})
			.catch((error) => {
				this.$log.error.call(this, error);
			});
		}
	},
	computed: {
		isTeacher: function() {
			return this.$UserSession.hasPriv.call(this, "APP_TEACHER");
		},
		isStudent: function() {
			return this.$UserSession.hasPriv.call(this, "APP_STUDENT");
		},
		canViewAllTests() {
			return this.$UserSession.hasPriv.call(this, "VIEW_ALLTESTS");
		},
		filteredTests() {
			const tests = [];
			for(const test of this.tests) {
				if(!this.search.filter || test.filters.includes(this.search.filter.id)) {
					tests.push(test);
				}
			}
			return tests;
		}
	}
};
</script>
